import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ExportedDataState } from '../../models/exported-data.model';

export const selectExportedDataState = createFeatureSelector<ExportedDataState>('exportedData');

export const selectFilters = createSelector(
  selectExportedDataState,
  (state: ExportedDataState) => state.filters
);

export const selectExportedData = createSelector(
  selectExportedDataState,
  (state: ExportedDataState) => state.data
);

export const selectIsLoading = createSelector(
  selectExportedDataState,
  (state: ExportedDataState) => state.isLoading
);

export const selectError = createSelector(
  selectExportedDataState,
  (state: ExportedDataState) => state.error
);